import request from "@/utils/request";

export function crossTypeAllForDropdown(params) {
    return request({
        url: "/api/services/app/CrossType/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function updateStandardCross(data) {
    return request({
        url: "/api/services/app/CrossType/UpdateStandardCross",
        method: "PUT",
        data
    });
}

export function crossTypeGetAllUnderTrial(params) {
    return request({
        url: "/api/services/app/CrossType/GetAllCrossTypeUnderTrial",
        method: "GET",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/cross_type.js